import Vue from "vue";
import router from "./router";
import App from "./App.vue";
import api from "./service/Webservice";
import VeeValidate from "vee-validate";
import shareService from "./service/ShareService";
import commonFunction from "./service/common-function";
// import store from  "./service/StoreService";
window.$ = window.jQuery = require("jquery");
import VueNumeric from "vue-numeric";
//import '../public/js/sorting.js'
// import VCalendar from "v-calendar";

// import storeService from "./service/StoreService"
import VueBreadcrumbs from "vue-breadcrumbs";
// import Calendar from "v-calendar/lib/components/calendar.umd";
import DatePicker from "v-calendar/lib/components/date-picker.umd";
import moment from "moment";
import "vuejs-noty/dist/vuejs-noty.css";
import VueNoty from "vuejs-noty";
import { library } from "@fortawesome/fontawesome-svg-core";
// import router from "./router";
import { faHatWizard } from "@fortawesome/free-solid-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import Pusher from "pusher-js";

Pusher.logToConsole = true;
Vue.component("font-awesome-icon", FontAwesomeIcon);
// Vue.use(store);
library.add(faHatWizard);
Vue.$api = api;
Vue.$shareService = shareService;

Object.defineProperty(Vue.prototype, "$api", {
  get() {
    return api;
  }
});
Vue.config.productionTip = false;
Vue.use(VeeValidate, {
  classes: true

  // classNames: {
  //   valid: "is-valid",
  //   invalid: "is-invalid"
  // }
});

// Vue.use(VCalendar, {
//   componentPrefix: "vc"
// });
Object.defineProperty(Vue.prototype, "$shareService", {
  get() {
    return shareService;
  }
});
Object.defineProperty(Vue.prototype, "$commonFunction", {
  get() {
    return commonFunction;
  }
});

Vue.mixin({
  methods: {
    capitalizeFirstLetter: str => str.charAt(0).toUpperCase() + str.slice(1),
  }
});

// Vue.component("calendar", Calendar);
Vue.component("date-picker", DatePicker);
Vue.use(VueNumeric);
Vue.use(VueBreadcrumbs);


Vue.use(VueNoty);
var Lang = require("vuejs-localization");
//Notice that you need to specify the lang folder, in this case './lang'
Lang.requireAll(require.context("../lang", true, /\.js$/));

Vue.use(Lang);

Vue.use(require("vue-moment"));
Vue.prototype.moment = moment;
String.prototype.toProperCase = function()
{
  return this.toLowerCase().replace(/^(.)|\s(.)/g, function($1) { return $1.toUpperCase(); });
}
new Vue({
  router,
  render: h => h(App)
}).$mount("#app");

Vue.filter("titleCase", function(value) {
  // if (!value) {
  //   return "";
  // } else {
  //   var str = "";
  //   var arr = value.split("_");
  //   for (var i = 0; i < arr.length; i++) {
  //     if (i == 0) {
  //       str =
  //         arr[i].charAt(0).toUpperCase() + arr[i].substring(1).toLowerCase();
  //     } else {
  //       str =
  //         " " +
  //         arr[i].charAt(0).toUpperCase() +
  //         arr[i].substring(1).toLowerCase();
  //     }
  //   }
  //   return str;
  // }


  if (!value) {
    return "";
}

const pattern = /_/gi;
const replacement = " ";
const result = value.replaceAll(pattern, replacement);
return result.toProperCase();
});

Vue.filter("formatCurrencyPos", function(amount, currency, position) {
  if (position == "pre") {
    if (amount) {
      return currency + " " + parseFloat(amount).toFixed(2);
    } else {
      return currency + " " + "0.00";
    }
  }
  if (position == "post") {
    if (amount) {
      return parseFloat(amount).toFixed(2) + " " + currency;
    } else {
      return "0.00" + " " + currency;
    }
  }
});

Vue.filter("checkNull", function(value) {
  if (value) {
    return value;
  } else {
    return "-";
  }
});

Vue.filter("formatDate", function(value) {
  if (value && value != null && value != '') {
    var preferred_date_format = localStorage.getItem("preferred_date_format");
    var testDateUtc = moment.utc(value);
    var localDate = moment(testDateUtc).local();

    return localDate.format(preferred_date_format);
  }
});

Vue.filter("capitalize", function(value) {
  if (value && value != null && value != '') {
    return value.toLowerCase().replace( /\b./g, function(a){ return a.toUpperCase(); } );
  }
});
Vue.filter("formatDateWithTime", function(value) {
  if (value && value != null && value != '') {
    var preferred_date_format = localStorage.getItem("preferred_date_format");
    var testDateUtc = moment.utc(value);
    var localDate = moment(testDateUtc).local();

    return localDate.format(preferred_date_format + "  " + "  hh:mm A ");
  }
});

Vue.filter("dateFilter", function(value) {
  if (value && value != null && value != '') {
    var testDateUtc = moment.utc(value);
    var localDate = moment(testDateUtc).local();

    var dif = Math.floor((Date.now() - localDate) / 1000 / 86400);

    if (dif < 30) {
      var date = this.$shareService.getDateObj(localDate),
        diff = (new Date().getTime() - date.getTime()) / 1000,
        daydiff = Math.floor(diff / 86400);

      if (isNaN(daydiff) || daydiff < 0 || daydiff >= 31) return "";

      return (
        (daydiff == 0 &&
          ((diff < 60 && "Just now") ||
            (diff < 120 && "1 minute ago") ||
            (diff < 3600 && Math.floor(diff / 60) + " minutes ago") ||
            (diff < 7200 && "1 hour ago") ||
            (diff < 86400 && Math.floor(diff / 3600) + " hours ago"))) ||
        (daydiff == 1 && "Yesterday") ||
        (daydiff < 7 && daydiff + " days ago") ||
        (daydiff < 31 && Math.ceil(daydiff / 7) + " weeks ago")
      );
    } else {
      var datePipe = new DatePipe("en-US");
      value = datePipe.transform(value, "MMM-dd-yyyy");
      return value;
    }

    return localDate.format("DD MMM YYYY | hh:mm A");
  }
});



// WEBPACK FOOTER //
// ./src/main.js